import { cn } from "utils/index";
import ReadOnlyText from "../../../base/basicComponents/readOnly-text";
import BaseComponent from "../../../base/common/BaseComponent";
import styles from "./style/index.module.scss";
import { Checkbox } from "antd";

const NaTag = ({ disabled, className }: any) => {
  return (
    <span
      className={cn(
        "flex items-center justify-center bg-[#e2e2e2] rounded-full w-[1.375rem] h-[1.375rem] min-h-[1.375rem] text-[0.5375rem] text-[#333333]",
        {
          "text-[#b3b3b3]": disabled,
        },
        className
      )}
    >
      N/A
    </span>
  );
};

class TaskInformation extends BaseComponent {
  taskInfoFieldComponent = (title: any, value: any) => {
    return (
      <div className={styles.taskInfoField}>
        <span className={styles.taskInfoFieldTitle}>{title}</span>
        <ReadOnlyText value={value} />
      </div>
    );
  };

  taskInfoMajorStepFieldComponent = (title: any, majorStepData: any) => {
    return (
      <div className={`${styles.taskInfoField} ${styles.fullWidthField}`}>
        <span className={styles.taskInfoFieldTitle}>{title}</span>
        <div className={styles.majorStepContainer}>
          {majorStepData.map((item: any, idx: any) => {
            const showCheckBox = item.isSelected || (!item.isSelected && !item.isNA);
            const showNATag = item.isNA || (!item.isSelected && !item.isNA);
            return (
              <div className={styles.majorStepItem} key={item.description + idx}>
                <div className={styles.majorStepItemTagContainer}>
                  <Checkbox
                    className={cn("opacity-0 pointer-events-none", {
                      "opacity-100": showCheckBox,
                    })}
                    checked={item.isSelected}
                    disabled
                  />

                  <NaTag
                    className={cn("opacity-0", {
                      "opacity-100": showNATag,
                    })}
                    disabled={!item.isNA}
                  />
                </div>
                <span className="text-sm leading-[1.125rem] text-[#333333]">
                  {item.description}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  render() {
    const { data, isInModal = false } = this.props;
    return (
      <div className={styles.taskInfoDiv}>
        {!isInModal && <p className={styles.taskInfoTitle}>Task Information</p>}
        <div className={isInModal ? styles.taskInfoModalFieldDiv : styles.taskInfoFieldDiv}>
          {this.taskInfoFieldComponent("Account Code", data.accountAbbr)}
          {this.taskInfoFieldComponent("Account Name", data.accountName)}
          {this.taskInfoFieldComponent("Account Manager", data.accountManager)}
          {this.taskInfoFieldComponent("Account Supervisor", data.accountSupervisor)}
          {this.taskInfoFieldComponent("Team Leader", data.accountTeamLeader)}
          {this.taskInfoFieldComponent("Task Group", data.taskGroupName)}
          {this.taskInfoFieldComponent("Category", data.categoryName)}
          {this.taskInfoFieldComponent("Task Label Name", data.taskLabelName)}
          {this.taskInfoFieldComponent("Task ID", data.taskID)}
          {this.taskInfoFieldComponent("Task Status", data.taskStatus)}
          {this.taskInfoFieldComponent(
            "Task Created Date",
            data.createdDate !== undefined &&
              data.createdDate !== null &&
              data.createdDate.trim() !== "" &&
              this._formateDate(data.createdDate)
          )}
          {this.taskInfoFieldComponent("Highly Regulated?", data.highRegulated)}
          {this.taskInfoFieldComponent("Turnaround Time", data.turnaroundTime)}
          {this.taskInfoFieldComponent("Temporary Task", data.temporaryTask)}
          {this.taskInfoFieldComponent("Standard Task Name", data.levelBName)}
          {this.taskInfoMajorStepFieldComponent("Major Step(s)", data.majorSteps ?? [])}
        </div>
      </div>
    );
  }
}

export default TaskInformation;
